module.exports = __webpack_public_path__ + "media/images/business/illust-user_base-8934344a4882eb35316487616ec6d003.svg";